var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "c-games_list c-games_list-wrap js-app-ul" },
    [
      _vm._l(_vm.apps, function(app, index) {
        return app.application.id != 5687110740738048
          ? _c(
              "li",
              {
                key: "app_item_" + app.application.id,
                class: ["js-app-li"],
                attrs: { id: "app_item_list_" + index }
              },
              [_c("game-entity", { attrs: { app: app, ua: _vm.ua } })],
              1
            )
          : _vm._e()
      }),
      _vm._v(" "),
      _vm._l(12, function(n) {
        return _vm.ua === "sp"
          ? _c("li", { key: "empty_" + n, staticClass: "is-empty" })
          : _vm._e()
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d82cc662", { render: render, staticRenderFns: staticRenderFns })
  }
}